export enum GenerationJobState {
  PENDING_DOCUMENT_CHUNKING = 'PENDING_DOCUMENT_CHUNKING'
}